import { render, staticRenderFns } from "./project-list-row.vue?vue&type=template&id=313c07f8&scoped=true&"
import script from "./project-list-row.vue?vue&type=script&lang=ts&"
export * from "./project-list-row.vue?vue&type=script&lang=ts&"
import style0 from "./project-list-row.vue?vue&type=style&index=0&id=313c07f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "313c07f8",
  null
  
)

export default component.exports